import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Authorize Local
import '@/assets/css/main.css'

import '@/assets/css/css/all.css'

import './assets/scss/authorizelocal/authorizecss.scss'

// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'

import JQuery from 'jquery'
window.$ = JQuery

import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)

import VueScratchable from 'vue-scratchable'

Vue.component('vue-scratchable', VueScratchable)

import moment from 'moment'

Vue.filter('formatDate', function (value) {
  if (value) {

    return moment(String(value), 'DDMMYYYY_HHmmss').format('DD/MM/YYYY HH:mm')
  }
})
Vue.filter('formatDateRegular', function (value) {
  if (value) {

    return moment(String(value), 'DD-MM-YYYY hh:mm:ss').format('DD/MM/YYYY hh:mm')
  }
})
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

import VueTreeList from 'vue-tree-list'

Vue.use(VueTreeList)

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

import VueBottomSheet from '@webzlodimir/vue-bottom-sheet'
Vue.use(VueBottomSheet)


import VueGoogleMap from 'vuejs-google-maps'
import 'vuejs-google-maps/dist/vuejs-google-maps.css'
Vue.use(VueGoogleMap, {
  load: {
    apiKey: process.env.VUE_APP_GOOGLE_KEY,
    libraries: ['places', 'visualization', 'geocoder']
  }
})

import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify: new Vuetify(),
  render: h => h(App)
}).$mount('#app')
